import React, { useState, useEffect } from "react";
import { Grid, TextField, Button } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { Search as SearchIcon } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import removalsActions from "../../../redux/actions/externalRemovals";

export default function Search() {
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [groupFilter, setGroupFilter] = useState("");

  const removals = useSelector((state) => state.externalRemovals);
  const groups = useSelector((state) => state.groups);
  const dispatch = useDispatch();

  useEffect(() => {
    const now = new Date();
    const end = now.toISOString().split("T")[0]; // hoy
    const threeMonthsAgo = new Date(now.setMonth(now.getMonth() - 3));
    const start = threeMonthsAgo.toISOString().split("T")[0];

    try {
      const parsed = JSON.parse(removals.search || '{}');
      setSearch(parsed.search || "");
      setStartDate(parsed.startDate || start);
      setEndDate(parsed.endDate || end);
    } catch (err) {
      console.warn("Search no era un JSON válido");
      setSearch("");
      setStartDate(start);
      setEndDate(end);
    }
  }, [removals.search]);

  useEffect(() => setGroupFilter(removals.groupID), [removals.groupID]);

  const handleSubmit = () => {
    if (new Date(startDate) > new Date(endDate)) {
      alert("La fecha de inicio no puede ser mayor que la de término");
      return;
    }

    const searchPayload = JSON.stringify({
      search,
      startDate,
      endDate,
    });

    dispatch(removalsActions.setSearch({ search: searchPayload }));
  };

  return (
    <Grid
      container
      alignItems="center"
      justify="space-between"
      spacing={2}
      style={{ marginBottom: 10 }}
    >
      <Grid item container xs={8} spacing={2} alignItems="center">
        <Grid item>
          <TextField
            variant="outlined"
            margin="dense"
            placeholder="nombre, apellido, email, teléfono"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Grid>
        <Grid item>
          <TextField
            variant="outlined"
            margin="dense"
            label="Fecha inicio"
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            InputLabelProps={{ shrink: true }} // necesario para que el label no se superponga con el date picker
          />
        </Grid>
  
        <Grid item>
          <TextField
            variant="outlined"
            margin="dense"
            label="Fecha final"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            style={{ height: 40, marginTop: 3 }}
            onClick={() => handleSubmit()}
            startIcon={<SearchIcon />}
          >
            Buscar
          </Button>
        </Grid>
      </Grid>
      <Grid item xs={4}>
        <Autocomplete
          fullWidth
          onChange={(e, k) => {
            if (!k) {
              setGroupFilter("");
              dispatch(removalsActions.setGroupID({ groupID: "" }));
            } else {
              setGroupFilter(k);
              dispatch(removalsActions.setGroupID({ groupID: k._id }));
            }
          }}
          options={groups.groupsSelect}
          value={groups.groupsSelect.find((gp) => gp._id === groupFilter._id)}
          getOptionLabel={(option) =>
            option ? option.name : "Selecciona un Grupo"
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Filtro por Grupo"
              margin="dense"
              variant="outlined"
            />
          )}
        />
      </Grid>
    </Grid>
  );
}
